import { render, staticRenderFns } from "./CardProfilePerson.vue?vue&type=template&id=4fd6cc75&scoped=true"
import script from "./CardProfilePerson.vue?vue&type=script&lang=js"
export * from "./CardProfilePerson.vue?vue&type=script&lang=js"
import style0 from "./CardProfilePerson.vue?vue&type=style&index=0&id=4fd6cc75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd6cc75",
  null
  
)

export default component.exports